import downloadFile from "../libs/DownloadFile";
import Fetcher from "../libs/Petition"

const url = '/role_releases';
const CREATED = 201;
const STATUS_OK = 200;

/**
 * 
 * @param headers Contiene la cabecera de autorización { Authorization: `Bearer ${token}` }
 * @param page [Opcional] Se utiliza para conocer la página en la que se encuentra
 * @param pageSize [Opcional] Se utiliza para especificar el tamaño de la página, es decir, la cantidad de registros que se obtendrán.
 * @param role_id [Opcional] Se usa para obtener únicamente los registros de un role
 * @returns Object {"data" => RoleReleases::collection(),"totalItems" => Cantidad de registros existentes}
 */
export const indexRoleReleases = async (props) => {
    const {
        headers,
        release_id,
        page,
        pageSize} = props;
    let response = [];
    try {
        // Parámetros requeridos
        let params = { release_id };
        // Parámetros opcionales
        if (page) params.page = page;
        if (pageSize) params.pageSize = pageSize;
        let fetch = await Fetcher({
            url: `${url}`,
            method: 'GET',
            params,
            headers
        });
        if (fetch.status === STATUS_OK)
            response = fetch.data;
    } catch (error) {
        response = {
            data: [],
            totalItems: 0
        };
    } finally {
        return response;
    }
}
/**
 * 
 * @param headers Contiene la cabecera de autorización { Authorization: `Bearer ${token}` }
 * @param role_release_id Identificador del comunicado sobre el que se hará la consulta
 * @returns Incident Retorna un objeto tipo Incident
 */
export const showRoleReleases = async ({ headers, role_release_id }) => {
    let response = [];
    try {
        let fetch = await Fetcher({
            url: `${url}/${role_release_id}`,
            method: 'GET',
            headers
        });
        if (fetch.status === STATUS_OK)
            response = fetch.data.data;
    } catch (error) {
        response = {};
    } finally {
        return response;
    }
}
/**
 * 
 * @param headers Contiene la cabecera de autorización { Authorization: `Bearer ${token}` }
 * @param data Contiene el objeto que se va a almacenar 
 * @returns Bool Retorna true si el objeto se almacena de manera satisfactoria, retorna FALSE si el objeto no se pudo almacenar 
 */
export const storeRoleReleases = async ({ headers, data }) => {
    let response = false;
    try {
        let fetch = await Fetcher({
            url: `${url}`,
            method: 'POST',
            data,
            headers
        });
        // console.log("Store releases: ", fetch);
        if (fetch.status === CREATED)
            response = fetch.data.data;
    } catch (error) {
        response = false;
    } finally {
        return response;
    }
}
/**
 * 
 * @param headers Contiene la cabecera de autorización { Authorization: `Bearer ${token}` }
 * @param data Contiene el objeto que se va a actualizar
 * @param role_release_id Identificador del comunicado que se va a modificar
 * @returns Bool Retorna true si el objeto se actualiza de manera satisfactoria, retorna FALSE si el objeto no se pudo actualizar 
 */
export const updateRoleReleases = async ({ headers, data, role_release_id }) => {
    let response = false;
    try {
        let fetch = await Fetcher({
            url: `${url}/${role_release_id}`,
            method: 'PUT',
            data,
            headers
        });
        if (fetch.status === STATUS_OK)
            response = fetch.data;
    } catch (error) {
        response = false;
    } finally {
        return response;
    }
}
/**
 * 
 * @param headers Contiene la cabecera de autorización { Authorization: `Bearer ${token}` }
 * @param role_release_id Identificador del comunicado que se va a eliminar
 * @returns Bool Retorna true si el objeto se elimina de manera satisfactoria, retorna FALSE si el objeto no se pudo eliminar 
 */
export const destroyRoleReleases = async ({ headers, role_release_id }) => {
    let response = true;
    try {
        let fetch = await Fetcher({
            url: `${url}/${role_release_id}`,
            method: 'DELETE',
            headers
        });
        if (fetch.status !== STATUS_OK)
            response = false;
    } catch (error) {
        response = false;
    } finally {
        return response;
    }
}

export const uploadRoleReleases = async ({ headers, role_release_id, data }) => {
    let response = false;
    try {
        let fetch = await Fetcher({
            url: `${url}/upload/${role_release_id}`,
            method: 'POST',
            data, headers
        });
        // console.log("Fetch Releases [upload]: ", fetch);
        if (fetch.status === CREATED)
            response = true;
    } catch (error) {
        response = false;
    } finally {
        return response;
    }
}

export const downloadRoleReleases = async ({ headers, role_release_id, name, toast }) => {
    let response = false;
    try {
        downloadFile({
            headers,
            url: `${url}/download/${role_release_id}`,
            type: 'application/json',
            name,
            toast
        });
        response = true;
    } catch (error) {
        response = false;
    } finally {
        return response;
    }
}